import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import axiosSecret from "../../axiosSecret/axiosSecret";

import LoadingData from "../Loading/LoadingData";
import OrderDeleteModal from "./OrderDeleteModal";

const ManggeOrders = () => {
    const [orderData, setOrderData] = useState(null);
    const [orders, setOrders] = useState([]);
    const [reFetch, setReFecth] = useState(false);
    useEffect(() => {
        const loadData = async () => {
            try {
                const { data } = await axios.get(
                    "https://elctrofy.herokuapp.com/all-orders"
                );
                setOrders(data);
            } catch (err) {
                console.error(err);
            }
        };
        loadData();
    }, [orderData, reFetch]);
    const handleNextStep = async (order) => {
        const id = order._id;
        const url = `https://elctrofy.herokuapp.com/shifted/${id}`;

        try {
            const { data } = await axiosSecret.put(url, order);
            toast.success("Product Status Updated.", {
                toastId: "shifted",
            });
            setReFecth(true);
        } catch (err) {
            console.log(err.message);
            console.log(err);
        }
    };
    return (
        <>
            <div className="w-full min-h-screen px-1 bg-gray-100 my-5 md:mb-10 lg:pt-8">
                <div className="lg:px-12 hidden md:block mx-auto sm:px-6 ">
                    <div className="flex flex-col">
                        <div className="-my-2 py-2 sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                            <div className="align-middle inline-block w-full shadow overflow-x-auto sm:rounded-lg border-b border-gray-200">
                                <table className="min-w-full table-auto">
                                    <thead>
                                        <tr className="border-b border-gray-200 font-thin bg-white leading-4 tracking-wider text-base text-gray-500">
                                            <th
                                                className="px-6 py-5 text-left"
                                                colSpan="100%"
                                            >
                                                <p>Manage All Orders</p>
                                            </th>
                                        </tr>
                                        <tr className="bg-gray-50 border-b border-gray-200 text-xs leading-4 text-gray-500 uppercase tracking-wider">
                                            <th className="px-6 py-3 text-left font-medium">
                                                <input
                                                    className="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                                                    type="checkbox"
                                                />
                                            </th>
                                            <th className="px-6 py-3 text-center font-medium">
                                                Product
                                            </th>
                                            <th className="px-6 py-3  font-medium text-center">
                                                Order Info
                                            </th>

                                            <th className="px-6 py-3 text-center font-medium">
                                                Canel Order
                                            </th>

                                            <th className="px-6 py-3 text-center font-medium">
                                                Payment
                                            </th>
                                            <th className="px-6 py-3 text-center font-medium">
                                                Status
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody className="bg-white">
                                        {orders.map((order) => (
                                            <tr key={order._id}>
                                                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                                                    <input
                                                        className="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                                                        type="checkbox"
                                                    />
                                                </td>
                                                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                                                    <div className="text-sm leading-5 text-gray-900">
                                                        <div className="flex flex-col items-center  justify-center">
                                                            <div className="flex-shrink-0 h-10 w-10">
                                                                <img
                                                                    className="h-10 w-10 rounded-full"
                                                                    src={
                                                                        order.productImg
                                                                    }
                                                                    alt="product"
                                                                />
                                                            </div>
                                                            <div>
                                                                <span className="font-semibold">
                                                                    {
                                                                        order.productName
                                                                    }
                                                                </span>
                                                            </div>
                                                            <div>
                                                                Orderd By:{" "}
                                                                <span className="font-semibold">
                                                                    {
                                                                        order.buyerName
                                                                    }
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-no-wrap border-b  border-gray-200">
                                                    <div className="flex flex-col items-center justify-center text-left">
                                                        <div>
                                                            <p className="text-left">
                                                                Qunatity:{" "}
                                                                {order.quantity}
                                                            </p>
                                                        </div>
                                                        <div>
                                                            <div>
                                                                <p className="text-sm text-left leading-5 font-medium text-gray-900">
                                                                    SubTotal:{" "}
                                                                    {
                                                                        order.subTotal
                                                                    }{" "}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-no-wrap text-center border-b border-gray-200 text-sm leading-5 font-medium">
                                                    <div className="flex justify-center items-center">
                                                        {order.paid ? (
                                                            <button
                                                                disabled
                                                                className="block disabled btn btn-success uppercase text-white border-2 border-green-500 px-3 py-2 rounded  font-poppins font-medium"
                                                            >
                                                                Cancel
                                                            </button>
                                                        ) : (
                                                            <label
                                                                htmlFor="order-delete"
                                                                onClick={() =>
                                                                    setOrderData(
                                                                        order
                                                                    )
                                                                }
                                                                className="btn btn-warning"
                                                            >
                                                                Cancel
                                                            </label>
                                                        )}
                                                    </div>
                                                </td>
                                                <td className="px-6 text-center py-4 whitespace-no-wrap border-b border-gray-200">
                                                    <span
                                                        className={`px-2 inline-flex  text-xs leading-5 font-semibold rounded-full ${
                                                            order.paid
                                                                ? "bg-green-100"
                                                                : "bg-green-300"
                                                        }  text-gray-800`}
                                                    >
                                                        {order.paid
                                                            ? "Paid"
                                                            : "Unpaid"}
                                                    </span>
                                                </td>

                                                <td className="px-6 py-4 whitespace-no-wrap text-center border-b border-gray-200 text-sm leading-5 font-medium">
                                                    <div className="flex justify-center items-center">
                                                        {order.paid ? (
                                                            <div>
                                                                {order.shifted ? (
                                                                    <button
                                                                        disabled
                                                                        className="block btn disabled  bg-teal-500 hover:bg-teal-600 text-white border-2 border-teal-500 hover:border-teal-600 px-3 py-2 rounded uppercase font-poppins font-medium"
                                                                    >
                                                                        Shifted
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        onClick={() =>
                                                                            handleNextStep(
                                                                                order
                                                                            )
                                                                        }
                                                                        className="block btn  bg-teal-500 hover:bg-teal-600 text-white border-2 border-teal-500 hover:border-teal-600 px-3 py-2 rounded uppercase font-poppins font-medium"
                                                                    >
                                                                        Next
                                                                        Step
                                                                    </button>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <button
                                                                disabled
                                                                className="block disabled btn  bg-teal-500  text-white border-2 border-teal-500  px-3 py-2 rounded uppercase font-poppins font-medium"
                                                            >
                                                                Pending
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                {/* mobile device  */}
                <div className="md:hidden w-full  lg:px-8">
                    <div className="flex flex-col">
                        <div className="flex justify-end   items-center py-5">
                            <NavLink
                                to="/dashboard/add-inventory-item"
                                className="inline-block px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline"
                            >
                                Add Product
                            </NavLink>
                        </div>

                        <div className="-my-2 py-2 sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                            <div className="align-middle inline-block w-full shadow overflow-x-auto sm:rounded-lg border-b border-gray-200">
                                <table className="min-w-full table-auto">
                                    <thead>
                                        <tr className="border-b border-gray-200 font-thin bg-white leading-4 tracking-wider text-base text-gray-500">
                                            <th
                                                className="px-6 py-5 text-left"
                                                colSpan="100%"
                                            >
                                                <p>Manage All Orders</p>
                                            </th>
                                        </tr>
                                        <tr className="bg-gray-50 border-b border-gray-200 text-xs leading-4 text-gray-500 uppercase tracking-wider">
                                            <th className="px-6 py-3 text-center font-medium">
                                                Order
                                            </th>

                                            <th className="px-6 py-3 text-center font-medium">
                                                Status
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody className="bg-white">
                                        {orders.map((order) => (
                                            <tr key={order._id}>
                                                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                                                    <div className="text-sm leading-5 text-gray-900">
                                                        <div className="flex flex-col items-center  justify-center">
                                                            <div className="flex-shrink-0 h-10 w-10">
                                                                <img
                                                                    className="h-10 w-10 "
                                                                    src={
                                                                        order.productImg
                                                                    }
                                                                    alt="product"
                                                                />
                                                            </div>
                                                            <div>
                                                                <span className="font-bold">
                                                                    {
                                                                        order.productName
                                                                    }
                                                                </span>
                                                            </div>
                                                            <div>
                                                                Orderd-By:{" "}
                                                                <span className="font-bold">
                                                                    {
                                                                        order.buyerName
                                                                    }
                                                                </span>
                                                            </div>
                                                            <div>
                                                                SubTotal:{" "}
                                                                <span className="font-bold">
                                                                    {
                                                                        order.subTotal
                                                                    }
                                                                </span>
                                                            </div>
                                                            <div>
                                                                Payment:{" "}
                                                                <span
                                                                    className={`px-2 inline-flex  text-xs leading-5 font-semibold rounded-full ${
                                                                        order.paid
                                                                            ? "bg-green-100"
                                                                            : "bg-green-300"
                                                                    }  text-gray-800`}
                                                                >
                                                                    {order.paid
                                                                        ? "Paid"
                                                                        : "Unpaid"}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td className="px-6 py-4 whitespace-no-wrap text-center border-b border-gray-200 text-sm leading-5 font-medium">
                                                    <div className="flex justify-center items-center">
                                                        {order.paid ? (
                                                            <button className="block  btn btn-success uppercase text-white border-2 border-green-500 px-3 py-2 rounded  font-poppins font-medium">
                                                                Shiped
                                                            </button>
                                                        ) : (
                                                            <button
                                                                onClick={() =>
                                                                    setOrderData(
                                                                        order
                                                                    )
                                                                }
                                                                className="block btn bg-red-500 hover:bg-red-400 text-white border-2 border-red-500 hover:border-red-400 px-3 py-2 rounded uppercase font-poppins font-medium"
                                                            >
                                                                Cancel
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                {orders.length === 0 ? (
                    <div className=" w-full my-10 z-50 overflow-hidden  opacity-75 flex flex-col items-center justify-center">
                        <div
                            className="spinner-border animate-spin inline-block text-teal-600 mb-10 w-14 h-14 border-6 rounded-full"
                            role="status"
                        ></div>
                        <div className=" mt-10">
                            <LoadingData />;
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>
            {orderData && (
                <OrderDeleteModal
                    setOrderData={setOrderData}
                    orderData={orderData}
                    url={`https://elctrofy.herokuapp.com/order-cancel/${orderData._id}`}
                />
            )}
        </>
    );
};

export default ManggeOrders;
